import { IUser } from '../../types/global/ListRender.types';
import {
    CommentLike,
    IAudition,
    IContest,
    IContestAward,
    IEvent,
    ILocation,
    IProject,
    IThougth,
    IUserSummary,
} from '../../types/global/helper';
import { IAdvertisement } from '../../types/global/media.types';
import { IFollowThspianModel } from '../audience/model';

export const types = {
    GET_MY_ACTIVITIES: 'GET_MY_ACTIVITIES',
    GET_MY_ACTIVITIES_SUCCESS: 'GET_MY_ACTIVITIES_SUCCESS',
    GET_MY_ACTIVITIES_FAIL: 'GET_MY_ACTIVITIES_FAIL',

    SAVE_ACTIVITY: 'SAVE_ACTIVITY',
    SAVE_ACTIVITY_SUCCESS: 'SAVE_ACTIVITY_SUCCESS',
    SAVE_ACTIVITY_FAIL: 'SAVE_ACTIVITY_FAIL',

    GET_SEARCH_SUGGESTIONS: 'GET_SEARCH_SUGGESTIONS',
    GET_SEARCH_SUGGESTIONS_SUCCESS: 'GET_SEARCH_SUGGESTIONS_SUCCESS',
    GET_SEARCH_SUGGESTIONS_FAIL: 'GET_SEARCH_SUGGESTIONS_FAIL',

    HIDE_MY_ACTIVITY: 'HIDE_MY_ACTIVITY',
    HIDE_MY_ACTIVITY_SUCCESS: 'HIDE_MY_ACTIVITY_SUCCESS',
    HIDE_MY_ACTIVITY_FAIL: 'HIDE_MY_ACTIVITY_FAIL',
    RESET_ACTIVITY_DATA: 'RESET_ACTIVITY_DATA',

    GET_ACTIVITY_FEED: 'GET_ACTIVITY_FEED',
    GET_ACTIVITY_FEED_SUCCESS: 'GET_ACTIVITY_FEED_SUCCESS',
    GET_ACTIVITY_FEED_FAIL: 'GET_ACTIVITY_FEED_FAIL',

    GET_FEED_SUGGESTION: 'GET_FEED_SUGGESTION',
    GET_FEED_SUGGESTION_SUCCESS: 'GET_FEED_SUGGESTION_SUCCESS',
    GET_FEED_SUGGESTION_FAIL: 'GET_FEED_SUGGESTION_FAIL',

    GET_FEED_COMMENT: 'GET_FEED_COMMENT',
    GET_FEED_COMMENT_SUCCESS: 'GET_FEED_COMMENT_SUCCESS',
    GET_FEED_COMMENT_FAIL: 'GET_FEED_COMMENT_FAIL',

    LIKE_ACTIVITY: 'LIKE_ACTIVITY',
    LIKE_ACTIVITY_SUCCESS: 'LIKE_ACTIVITY_SUCCESS',
    LIKE_ACTIVITY_FAIL: 'LIKE_ACTIVITY_FAIL',

    DELETE_ACTIVITY_LIKE: 'DELETE_ACTIVITY_LIKE',
    DELETE_ACTIVITY_LIKE_SUCCESS: 'DELETE_ACTIVITY_LIKE_SUCCESS',
    DELETE_ACTIVITY_LIKE_FAIL: 'DELETE_ACTIVITY_LIKE_FAIL',

    GET_PERSISTENT_FEED: 'GET_PERSISTENT_FEED',
    GET_PERSISTENT_FEED_SUCCESS: 'GET_PERSISTENT_FEED_SUCCESS',
    GET_PERSISTENT_FEED_FAIL: 'GET_PERSISTENT_FEED_FAIL',

    WARM_TIMELINE: 'WARM_TIMELINE',
    WARM_TIMELINE_SUCCESS: 'WARM_TIMELINE_SUCCESS',
    WARM_TIMELINE_FAIL: 'WARM_TIMELINE_FAIL',
};

/** Note, in regards to activities */
export type TFeedComment = 'project' | 'contest' | 'thougth' | 'act';
export interface IGetFeedComment {
    category: TFeedComment;
    categoryId: string;
    /** allows fetching replies if specified */
    parent_comment: string;
    page?: number;
    limit?: number;
}

export interface IWarmTimeline {
    email: string;
}

export interface IFeedCommentPagination {
    total: number;
    totalPages: number;
    page: number;
    limit: number;
    hasNextPage: boolean;
    category: TFeedComment;
}

export interface IFeedCommentRsponse {
    pagination: IFeedCommentPagination;
    data: IFeedComment[];
    parent_comment: string;
}

export interface IFeedComment {
    _id: string;
    project?: string;
    thougth?: string;
    contest?: string;
    act?: string;
    comment: string;
    created_by: IUserSummary;
    created_at: string;
    createdAt: string;
    total_likes?: number;
    total_anger?: number;
    total_love?: number;
    user_like: CommentLike[];
    is_user_liked: boolean;
    first_replies: IFeedComment[];
    total_replies: number;
    replies?: IFeedComment[];
    pagination?: {
        hasNextPage: boolean;
        currentPage: number;
        limit: number;
        nextPage: number;
    };
}

export interface ISaveSearchActivityPayload {
    activity_type: Activity;
    metadata: {
        search_term: string;
    };
}

export type TActivityLikeCategory = 'contest' | 'thougth' | 'event' | 'project' | 'campaign' | 'job' | 'gig';

export interface ILikeActivity {
    activityId: string;
    like_category: TActivityLikeCategory;
    like_type: 'like' | 'dislike';
    like_origin?: 'home' | 'details' | 'profile' | 'watch';
    /** For redirect */
    redirect?: string;
    location?: string;
}

export interface IDeleteActivityLike {
    likeId: string;
    activityId: string;
    like_category: TActivityLikeCategory;
    like_origin?: 'home' | 'details' | 'profile' | 'watch';
    /** Additional payload containing the activity being unliked */
    additionalPayload?: any;
}

export interface ITimeline {
    /** Displays the timeline of people on thspian based on time created */
    chronological: {
        data: IActivityFeedItem[];
        page: number;
        limit: number;
        canLoadMore: boolean;
        loading: boolean;
        currentPagination?: Pagination;
        nextCursor?: ICursor | null;
    };
    /** Displays timeline of people you are following */
    following: {
        data: IActivityFeedItem[];
        page: number;
        limit: number;
        canLoadMore: boolean;
        loading: boolean;
        currentPagination?: Pagination;
        nextCursor?: ICursor | null;
    };
    /** Displays timeline of interests that you might have */
    interest: {
        data: IActivityFeedItem[];
        page: number;
        limit: number;
        canLoadMore: boolean;
        loading: boolean;
        currentPagination?: Pagination;
        nextCursor?: ICursor | null;
    };
}

export interface TimelinePage {
    chronological: number;
    following: number;
    interest: number;
}

export interface IActivityInitialState {
    myActivities: ActivityResponse[];
    savingActivity: boolean;
    gettingActivity: boolean;
    errMsg: any;
    searchSuggestions: SearchSuggestion[];
    processing?: boolean;
    nextCursor?: ICursor | null;
    firstCursor: ICursor[];
    feedPage?: number;
    timeline: ITimeline;
    timelinePage: TimelinePage;
    fetchingTimeline?: boolean;
    requestedCategory?: string;
    feedSuggestion?: IFeedSuggestion;
    fetchingSuggestion?: boolean;
    bookmarking?: boolean;
    filters?: IFeedFilter[];
    fetchingFilters?: boolean;
    feedComments?: IFeedCommentRsponse | null;
    fetchingFeedComments?: boolean;
    fetchingMoreReplies?: boolean;
    currentComments: IFeedComment[];
    currentCommentsCategory?: TFeedComment;
    currentCommentsCategoryId?: string;
    likingActivity?: boolean;
    deletingActivityLike?: boolean;
}

export type ActivityType =
    | 'commented on project'
    | 'commented on contest'
    | 'joined a contest'
    | 'voted for project'
    | 'joined thspian'
    | 'initiated a search'
    | 'viewed a project'
    | 'created a project'
    | 'added team member'
    | 'liked a project'
    | 'liked a review'
    | 'liked a movie'
    | 'liked an act'
    | 'liked a comment'
    | 'liked a contest'
    | 'initiated a search'
    | 'created a contest'
    | 'won a contest 🥳🥳🥳🥳🚀🚀🚀🚀🎉🎉🎉🎉'
    | 'created an event'
    | 'created a gig'
    | 'shared a gig'
    | 'shared an event'
    | 'applied to a gig'
    | 'got hired'
    | 'is hiring'
    | 'is casting'
    | 'applied to a gig'
    | 'liked a thougth'
    | 'created a thougth'
    | 'shared a thougth'
    | 'commented on a thougth';

export enum ACTIVITY_TYPE {
    /** Add more activity types here. The service usually handles these behind the scene but in some instances we need to initiare them */
    INITIATED_A_SEARCH = 'initiated a search',
}

export interface ActivityRootResponse {
    status: string;
    results: number;
    data: Data;
}

export interface Data {
    data: ActivityResponse[];
}

export interface ActivityResponse {
    activity?: Activity;
    _id: string;
    user: string;
    activity_type: ActivityType;
    created_by: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    id: string;
    metadata?: Metadata;
}

export interface ActivityItem {
    project_type?: string;
    total_likes?: number;
    total_comments?: number;
    view_count?: number;
    _id: string;
    title?: string;
    description?: string;
    project: any;
    id?: string;
    feature_image?: string;
    profile_picture?: string;
    role?: string;
}

export interface Metadata {
    search_term: string;
}

export interface SearchSuggestionResponse {
    status: string;
    data: SearchSuggestion[];
}

export interface SearchSuggestion {
    _id: string;
    count?: number;
    documents?: ActivityDocument;
    details?: SuggestionDetails;
    suggestionType?: SuggestionDetailsTypes;
    suggestion?: IContest | IProject | IUser | IAudition | IEvent;
}

export interface ActivityDocument {
    _id?: string;
    user?: string;
    activity_type?: ActivityType | string;
    activity?: Activity;
    metadata?: Metadata;
    created_by?: string;
    createdAt?: string;
    updatedAt?: string;
    __v?: number;
}

export interface Activity {
    type: 'User' | 'Project' | 'Like' | 'Contest' | 'Event' | 'Audition' | string;
    model: ActivityItem;
}

export interface Metadata {
    search_term: string;
}

export type SuggestionDetailsTypes = 'contest' | 'user' | 'projects' | 'talent' | 'audition' | 'event';

export interface SuggestionDetails {
    projects: Project[];
    user: User[];
    contest: Contest[];
}

export interface Project {
    _id: string;
    project_type: string;
    project_gallery: any[];
    visible: boolean;
    team: any[];
    status: string;
    trending_marker: number;
    total_likes: number;
    total_anger: number;
    total_love: number;
    scheduled_published_date: string;
    mentions: any[];
    total_comments: number;
    view_count: number;
    last_seen: string;
    title: string;
    description: string;
    created_by: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    project: string;
}

export interface User {
    _id: string;
    location: Location;
    role: string;
    active: boolean;
    phone_verified: boolean;
    email_verified: boolean;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phoneNumber: number;
    stripeCustomerId: string;
    __v: number;
    email_verify_token: string;
    passwordResetExpires: string;
    passwordResetToken: string;
    profile_picture: string;
    userName: string;
    paystack_customer_code: string;
    current_subscription: string;
    application_limit: number;
    casting_call_limit: number;
    audme_profile: string;
    permissions: string[];
    verified?: boolean;
    user_type: string[];
}

export interface Location {
    type: string;
    description: string;
    address: string;
    coordinates: number[];
}

export interface Contest {
    _id: string;
    requirements: string[];
    contest_media: any[];
    voting_required: boolean;
    voting_type: string;
    tag: string[];
    date_start: string;
    expiration_date: string;
    contest_phases_enabled: boolean;
    premium: boolean;
    contest_phase: string;
    status: string;
    trending_marker: number;
    title: string;
    description: string;
    created_by: string;
    contest_phase_dates: any[];
    __v: number;
    feature_image: string;
    total_likes: number;
    total_comments: number;
}

export interface FeedActivity {
    type: 'User' | 'Project' | 'Like' | 'Contest' | 'Event' | 'Audition' | string;
    model: IContest | IAudition | IProject | IEvent | IThougth | null;
}

export interface FeedCreatedBy extends IUserSummary {
    /** Does the current target user follow the logged in user */
    follows_user?: boolean;
    /** Is the current logged in user following the current user */
    user_following?: boolean;
    /** The object of the logged in user following */
    user_follow_interaction?: IFollowThspianModel[];
    /** The total number of followers the user in target has */
    following_count?: number;
    /** 5 followers of the user */
    followings?: IFollowThspianModel[];
    /** Followers that follow both the user and myself */
    mutual_followers?: IFollowThspianModel[];
}

export interface FeedActivityResponse {
    activity?: FeedActivity;
    _id: string;
    user: string;
    activity_type: ActivityType;
    created_by: FeedCreatedBy;
    createdAt: string;
    updatedAt: string;
    __v?: number;
    id?: string;
}

export interface IActivityFeedItem extends FeedActivityResponse {
    collection_exists?: boolean;
    auditions_activity?: IAudition; // Optional, can be contests_activity or events_activity
    contests_activity?: IContest;
    projects_activity?: IProject;
    events_activity?: IEvent;
    thougths_activity?: IThougth;
}

export interface IGetFeed extends Pagination {
    activity_type?: FeedSubresource;
    cursor?: ICursor | null;
}

export type TFeedCategory = 'following' | 'interest' | 'chronological';

export interface Pagination {
    page?: number;
    limit?: number;
    category?: TFeedCategory;
    count?: Record<TFeedCategory, number>; // Using Record for category-based counts
    older?: boolean;
    startDate?: string;
    endDate?: string;
    /** Allows us fetch older items */
    show_seen?: boolean;
}

export interface ICursor {
    lastCreatedAt: string;
    lastId: string;
    hasMore: boolean;
}

export interface ICursors {
    following: ICursor;
    interest: ICursor;
    chronological: ICursor;
}

export interface IHasMore {
    following: boolean;
    interest: boolean;
    chronological: boolean;
}

export interface ICount {
    following: number;
    interest: number;
    chronological: number;
}

export interface IActivityPagination extends Pagination {
    /** Next cursor to call */
    cursor?: ICursor | null;
    hasMore?: boolean;
    cursors?: ICursors;
    hasMoreByCategory: IHasMore;
    count: ICount;
    category: 'interest' | 'chronological' | 'following';
}

export type FeedSubresource = 'gig' | 'event' | 'campaign' | 'thougth' | 'project' | 'none' | string;
export interface IFeedFilter {
    name: string;
    resource: string;
    subresource: string;
    location?: ILocation;
}
export interface IGetFeedResponse {
    pagination?: IActivityPagination;
    following?: IActivityFeedItem[];
    interest?: IActivityFeedItem[];
    chronological?: IActivityFeedItem[];
    filters?: IFeedFilter[];
    older?: boolean;
}

export interface IGetPersistentFeed {
    isLoadMore?: boolean;
    isRefresh?: boolean;
}
export interface TimelineUrls {
    following: string;
    interest: string;
    chronological: string;
}

export interface FilterUrls {
    filters: string;
}

export interface IGetFeedResponseForS3 {
    pagination: Pagination;
    timelineUrls: TimelineUrls;
    filterUrls: FilterUrls;
}

interface ICcontestsFromFollowedUsers {
    /** Id of the contest */
    _id: string;
    contest: IContest;
    userCount: number;
    users: IUserSummary[];
}

interface FeedContestSubmissions {
    _id: string;
    created_by: IUserSummary;
}
export interface IContestSummary
    extends Pick<
        IContest,
        | 'title'
        | 'description'
        | 'feature_image'
        | 'contest_id'
        | 'is_feature'
        | 'rating'
        | 'host'
        | 'partner'
        | 'contest_phase_dates'
        | '_id'
        | 'slug'
    > {
    // Add additional properties or methods here if needed
    total_submissions: number;
    submissions: FeedContestSubmissions[];
}
export interface IFeedSuggestionContest {
    contestsFromFollowedUsers: ICcontestsFromFollowedUsers;
    contestsFromFollowers: ICcontestsFromFollowedUsers;
    liveCampaigns: IContestSummary[];
}

export interface IeventUserIsFollowingIsAttending {
    eventDetails: IEvent;
    userCount: number;
    userDetails: IUserSummary[];
}

export interface IFeedSuggestionEvents {
    liveEvents: IEvent[];
    eventUserIsFollowingIsAttending: IeventUserIsFollowingIsAttending[];
    eventFollowingUserBeingAttended: IeventUserIsFollowingIsAttending[];
    hotEvents: IeventUserIsFollowingIsAttending[];
}

export interface IFeedSuggestionUsers {
    castingDirectorUsers: IUserSummary[];
    talentUsers: IUserSummary[];
    crewUsers: IUserSummary[];
    awardWinnersUsers: IContestAward[];
}

export interface IFeedSuggestionGigs {
    activeGigs: IAudition[];
}

export interface IFeedSuggestion {
    ads: IAdvertisement[];
    contests: IFeedSuggestionContest;
    events: IFeedSuggestionEvents;
    users: IFeedSuggestionUsers;
    gigs: IFeedSuggestionGigs;
}
